import { CLINICAL_FORM_DENTAL } from './clinicalFormTemplates';

export const DENTAL_INTAKE_SCHEMA_VERSION = 1;

export function emptyDentalIntake(header = {}) {
  return {
    form_template: CLINICAL_FORM_DENTAL,
    schema_version: DENTAL_INTAKE_SCHEMA_VERSION,
    header: {
      folio: '',
      form_date: new Date().toISOString().slice(0, 10),
      ...header,
    },
    edad: '',
    medical_history: '',
    allergies: '',
    medications: '',
    chief_complaint: '',
    dental_history: '',
    odontogram: '',
    exam_findings: '',
    diagnosis: '',
    treatment_plan: '',
    photo_consent: false,
    treatment_consent: false,
    consent_name: '',
  };
}

export function mergeDentalIntake(saved) {
  const base = emptyDentalIntake();
  if (!saved || typeof saved !== 'object') return base;
  return {
    ...base,
    ...saved,
    form_template: CLINICAL_FORM_DENTAL,
    schema_version: DENTAL_INTAKE_SCHEMA_VERSION,
    header: { ...base.header, ...(saved.header || {}) },
    edad: String(saved.edad ?? '').trim(),
    medical_history: String(saved.medical_history ?? '').trim(),
    allergies: String(saved.allergies ?? '').trim(),
    medications: String(saved.medications ?? '').trim(),
    chief_complaint: String(saved.chief_complaint ?? '').trim(),
    dental_history: String(saved.dental_history ?? '').trim(),
    odontogram: String(saved.odontogram ?? '').trim(),
    exam_findings: String(saved.exam_findings ?? '').trim(),
    diagnosis: String(saved.diagnosis ?? '').trim(),
    treatment_plan: String(saved.treatment_plan ?? '').trim(),
    photo_consent: Boolean(saved.photo_consent),
    treatment_consent: Boolean(saved.treatment_consent),
    consent_name: String(saved.consent_name ?? '').trim(),
  };
}
